"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_DE_TRANS = {
    'time picker': 'Zeit wählen',
    'today': 'Heute',
    'set time': 'Zeit festlegen',
    'close': 'Schließen',
    'cancel': 'Entfernen',
    'confirm': 'Bestätigen',
    'hour': 'Stunde',
    'minute': 'Minute',
    'second': 'Sekunde',
};
//# sourceMappingURL=de.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/de.js
// module id = ../../../../ng-pick-datetime/locale/de.js
// module chunks = 15